import {
  SchoolID,
  SchoolType,
  SchoolTypeOptions,
} from "../../editing_planning/data_requirements";

interface SchoolSearch {
  [key: string]: {
    key: string;
    name: string;
    assignments: {
      [key in SchoolTypeOptions]?: AssignedSchool[];
    };
  };
}
export interface AssignedSchool {
  sch_level: SchoolType;
  sch_id: SchoolID;
  sch_name: string;
  fac_id: string;
}

export interface SearchedAddressResponse {
  schools: SchoolSearch;
  geometry: AddressPoint;
}

export interface AddressPoint {
  type: "point";
  coordinates: number[];
}

export type MetricCategoryObject = Partial<
  Record<
    MetricCategory,
    {
      key: string;
      metrics: { [key in Partial<MetricType>]: Metric };
    }
  >
>;

export interface Metric {
  name: MetricType;
  value: string | number | boolean;
  key: string;
}

// enum MetricTypeOptions {
//   util_band = "util_band",
//   pct_at_risk = "pct_at_risk",
//   ib_pct_at_risk = "ib_pct_at_risk",
//   not_ib_pct_at_risk = "not_ib_pct_at_risk",
//   amind_nat_tm_other_pct = "amind_nat_tm_other_pct",
//   asian_pct = "asian_pct",
//   black_pct = "black_pct",
//   latinx_pct = "latinx_pct",
//   white_pct = "white_pct",
//   not_ib_amind_nat_tm_other_pct = "not_ib_amind_nat_tm_other_pct",
//   not_ib_asian_pct = "not_ib_asian_pct",
//   not_ib_black_pct = "not_ib_black_pct",
//   not_ib_latinx_pct = "not_ib_latinx_pct",
//   not_ib_white_pct = "not_ib_white_pct",
//   ib_amind_nat_tm_other_pct = "ib_amind_nat_tm_other_pct",
//   ib_asian_pct = "ib_asian_pct",
//   ib_black_pct = "ib_black_pct",
//   ib_latinx_pct = "ib_latinx_pct",
//   ib_white_pct = "ib_white_pct",
//   med_ib_dist = "med_ib_dist",
//   med_oob_dist = "med_oob_dist",
// }

export const metricToUnitMap = {
  util_band: "str",
  utilization: "pct",
  enrollment: "str",
  capacity: "str",
  pct_at_risk: "pct",
  ib_pct_at_risk: "pct",
  not_ib_pct_at_risk: "pct",
  amind_nat_tm_other_pct: "pct",
  asian_pct: "pct",
  black_pct: "pct",
  latinx_pct: "pct",
  white_pct: "pct",
  not_ib_amind_nat_tm_other_pct: "pct",
  not_ib_asian_pct: "pct",
  not_ib_black_pct: "pct",
  not_ib_latinx_pct: "pct",
  not_ib_white_pct: "pct",
  ib_amind_nat_tm_other_pct: "pct",
  ib_asian_pct: "pct",
  ib_black_pct: "pct",
  ib_latinx_pct: "pct",
  ib_white_pct: "pct",
  ib_med_car_dist: "dist",
  oob_med_car_dist: "dist",
  med_car_dist_oob: "dist",
  med_car_dist_ib: "dist",
  schs_30pct_diff_at_risk: "str",
  schs_50pct_diff_at_risk: "str",
  util_lt50: "str",
  util_50_65: "str",
  util_65_80: "str",
  util_80_95: "str",
  util_95_110: "str",
  util_gt110: "str",
  pct_dcps_highest_osse: "pct",
  pct_dcps_highest_osse_at_risk: "pct",
  osse_at_risk: "pct",
  weighted_framework_score: "str",
  pct_dcps_at_risk_highest_demand: "pct",
  pct_dcps_highest_demand: "pct",
  is_highest_demand: "bool",
};

export const MetricCategoryNamesMap = {
  utilization: "Utilization",
  demographics: "Demographics",
  distance: "Distance",
  demand_quality: "Demand/Quality",
};

type MetricType = string;

export type MetricCategory = "utilization" | "change_type";

export const filterInvalidCategories = (input: string[]): MetricCategory[] => {
  return input.filter((value) =>
    ["utilization"].includes(value),
  ) as MetricCategory[];
};

interface ChangeType {
  name: string;
  value: false;
  key: string;
}

type ChangeTypeOptions =
  | "feeder_chg"
  | "shared_space"
  | "oob_reduce"
  | "ec_annex"
  | "grade_config"
  | "paired_school"
  | "set_aside"
  | "is_cardozo_ms";

export type ChangeTypeDict = {
  [key in ChangeTypeOptions]: ChangeType;
};
